export const DELETE_ADVERTISEMENT_START =
  'DELETE_ADVERTISEMENT_START';
export const DELETE_ADVERTISEMENT_SUCCESS =
  'DELETE_ADVERTISEMENT_SUCCESS';
export const DELETE_ADVERTISEMENT_ERROR =
  'DELETE_ADVERTISEMENT_ERROR';
